import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';

// Range datepicker Start
const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
    one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
    !one || !two
        ? false
        : one.year === two.year
            ? one.month === two.month
                ? one.day === two.day
                    ? false
                    : one.day < two.day
                : one.month < two.month
            : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
    !one || !two
        ? false
        : one.year === two.year
            ? one.month === two.month
                ? one.day === two.day
                    ? false
                    : one.day > two.day
                : one.month > two.month
            : one.year > two.year;
@Component({
    selector: 'app-custom-date-picker',
    templateUrl: './custom-date-picker.component.html',
    styleUrls: ['./custom-date-picker.component.scss'],
})
export class CustomDatePickerComponent implements OnInit {
    @Input() hoveredDate: NgbDateStruct;
    @Input() fromDate: NgbDateStruct;
    @Input() toDate: NgbDateStruct;
    @Input() formattedFromDate: string;
    @Input() formattedToDate: string;
    constructor(private activeModal: NgbActiveModal) {}

    ngOnInit(): void {}

    isHovered = (date) =>
        this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate);
    isInside = (date) => after(date, this.fromDate) && before(date, this.toDate);
    isFrom = (date) => equals(date, this.fromDate);
    isTo = (date) => equals(date, this.toDate);
    onDateChange(date: NgbDateStruct) {
        // Convert NgbDateStruct to JavaScript Date
        const jsDate = new Date(date.year, date.month - 1, date.day);

        // Convert to South Africa time zone (UTC+2)
        const southAfricaTime = new Date(jsDate.toLocaleString('en-US', { timeZone: 'Africa/Johannesburg' }));

        // Format the date as needed
        const formattedDate = southAfricaTime.toLocaleString('en-ZA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour12: false,
        });

        // Handle date selection logic
        if (!this.fromDate && !this.toDate) {
            this.formattedFromDate = formattedDate;
            this.fromDate = date;
        } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
            this.toDate = date;
            this.formattedToDate = formattedDate;
        } else {
            this.toDate = null; // Reset toDate
            this.formattedFromDate = formattedDate;
            this.fromDate = date;
        }
        if (this.formattedFromDate && this.formattedToDate) {
            this.activeModal.close({
                fromDate: this.fromDate,
                toDate: this.toDate,
                formattedFromDate: this.formattedFromDate,
                formattedToDate: this.formattedToDate,
            });
        }
    }
}
